interface EmptyStateProps {
  hasSearch: boolean;
  onClearSearch: () => void;
}

const EmptyState = ({ hasSearch, onClearSearch }: EmptyStateProps) => {
  if (hasSearch) {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-4">
        <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
          <i className="ri-search-line text-5xl text-gray-400"></i>
        </div>
        <h3 className="text-2xl font-semibold text-gray-900 mb-3">
          No brands match your search
        </h3>
        <p className="text-gray-600 mb-6 text-center max-w-md">
          Try adjusting your search keywords or clear the search to see all brands.
        </p>
        <button
          onClick={onClearSearch}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          Clear Search
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <i className="ri-store-line text-5xl text-gray-400"></i>
      </div>
      <h3 className="text-2xl font-semibold text-gray-900 mb-3">
        No brands available yet
      </h3>
      <p className="text-gray-600 text-center max-w-md">
        We are still onboarding brands. Please check back later.
      </p>
    </div>
  );
};

export default EmptyState;
